/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_S4Inputs */

const en_mk_tut_chat_s4 = /** @type {(inputs: Mk_Tut_Chat_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the conversation turns out to be real work, convert the message into an issue from the message menu.`)
};

const id_mk_tut_chat_s4 = /** @type {(inputs: Mk_Tut_Chat_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau obrolan ternyata pekerjaan sungguhan, ubah pesannya menjadi issue lewat menu di pesan itu.`)
};

/**
* | output |
* | --- |
* | "If the conversation turns out to be real work, convert the message into an issue from the message menu." |
*
* @param {Mk_Tut_Chat_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_s4 = /** @type {((inputs?: Mk_Tut_Chat_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_s4(inputs)
	return en_mk_tut_chat_s4(inputs)
});